import { getTheme } from '../utils/themes';

export const useRoomTheme = (type) => {
  const theme = getTheme(type);
  return { theme };
};
